<script>
import { Line, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'EnergyChart',
  extends: Line,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = 'mwh';
                    if (label) {
                        label += ': ';
                    }
                    if (value > 1000000000000000) {
                        unit = 'TWh';
                        value = Math.round(value / 1000000000000000 * 10) / 10
                    } else if (value > 1000000000000) {
                        unit = 'GWh';
                        value = Math.round(value / 1000000000000 * 10) / 10
                    } else if (value > 1000000000) {
                        unit = 'MWh';
                        value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value > 1000000) {
                        unit = 'kWh';
                        value = Math.round(value / 1000000 * 10) / 10
                    } else if (value > 1000) {
                        unit = 'Wh';
                        value = Math.round(value / 1000 * 10) / 10
                    } else {
                        value = Math.round(value * 10) / 10
                    }

                    label += value + ' ' + unit;
                    return label;
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
            }],
            yAxes: [{
                ticks: {
                  min: 0,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = 'mwh';
                      if (value > 1000000000000000) {
                          unit = 'TWh';
                          value = Math.round(value / 1000000000000000 * 10) / 10
                      } else if (value > 1000000000000) {
                          unit = 'GWh';
                          value = Math.round(value / 1000000000000 * 10) / 10
                      } else if (value > 1000000000) {
                          unit = 'MWh';
                          value = Math.round(value / 1000000000 * 10) / 10
                      } else if (value > 1000000) {
                          unit = 'kWh';
                          value = Math.round(value / 1000000 * 10) / 10
                      } else if (value > 1000) {
                          unit = 'Wh';
                          value = Math.round(value / 1000 * 10) / 10
                      } else {
                          value = Math.round(value * 10) / 10
                      }
                      label += value + ' ' + unit;
                      return label;
                    }
                },
                stacked:false,
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>